"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppBusyComponent = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _Portal = _interopRequireDefault(require("../Modal/Portal"));

var _activableRenderer = _interopRequireDefault(require("../Modal/activableRenderer"));

var _Overlay = _interopRequireDefault(require("../Overlay"));

var _appBusy = _interopRequireDefault(require("./assets/app-busy.gif"));

var _ThemeProvider = require("../../ThemeProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AppBusy =
/*#__PURE__*/
function (_Component) {
  _inherits(AppBusy, _Component);

  function AppBusy() {
    _classCallCheck(this, AppBusy);

    return _possibleConstructorReturn(this, _getPrototypeOf(AppBusy).apply(this, arguments));
  }

  _createClass(AppBusy, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          className = _this$props.className,
          type = _this$props.type,
          active = _this$props.active,
          onOverlayClick = _this$props.onOverlayClick,
          onEscKeyDown = _this$props.onEscKeyDown,
          onOverlayMouseDown = _this$props.onOverlayMouseDown,
          onOverlayMouseMove = _this$props.onOverlayMouseMove,
          onOverlayMouseUp = _this$props.onOverlayMouseUp;
      var classNames = (0, _classnames2["default"])([theme.dialog, theme[type]], _defineProperty({}, theme.active, active), className);
      return _react["default"].createElement(_Portal["default"], {
        className: theme.wrapper
      }, _react["default"].createElement(_Overlay["default"], {
        active: active,
        className: theme.overlay,
        theme: theme,
        themeNamespace: "overlay",
        onClick: onOverlayClick,
        onEscKeyDown: onEscKeyDown,
        onMouseDown: onOverlayMouseDown,
        onMouseMove: onOverlayMouseMove,
        onMouseUp: onOverlayMouseUp
      }), _react["default"].createElement("div", {
        "data-react-toolbox": "dialog",
        className: classNames
      }, _react["default"].createElement("section", {
        className: theme.body
      }, _react["default"].createElement("div", {
        className: theme.top
      }, _react["default"].createElement("strong", {
        className: theme.title
      }, "we are gathering your information\u2026"), _react["default"].createElement("img", {
        className: theme.appAnimation,
        src: _appBusy["default"],
        role: "presentation"
      })))));
    }
  }]);

  return AppBusy;
}(_react.Component);

exports.AppBusyComponent = AppBusy;

_defineProperty(AppBusy, "propTypes", {
  active: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  onEscKeyDown: _propTypes["default"].func,
  onOverlayClick: _propTypes["default"].func,
  onOverlayMouseDown: _propTypes["default"].func,
  onOverlayMouseMove: _propTypes["default"].func,
  onOverlayMouseUp: _propTypes["default"].func,
  theme: _propTypes["default"].shape({
    active: _propTypes["default"].string,
    body: _propTypes["default"].string,
    button: _propTypes["default"].string,
    dialog: _propTypes["default"].string,
    navigation: _propTypes["default"].string,
    overlay: _propTypes["default"].string,
    title: _propTypes["default"].string,
    wrapper: _propTypes["default"].string
  }).isRequired,
  type: _propTypes["default"].string
});

_defineProperty(AppBusy, "defaultProps", {
  className: null,
  active: false,
  type: 'normal',
  onEscKeyDown: function onEscKeyDown() {},
  onOverlayClick: function onOverlayClick() {},
  onOverlayMouseDown: function onOverlayMouseDown() {},
  onOverlayMouseMove: function onOverlayMouseMove() {},
  onOverlayMouseUp: function onOverlayMouseUp() {}
});

var _default = (0, _ThemeProvider.applyTheme)('AppBusy', (0, _activableRenderer["default"])()(AppBusy));

exports["default"] = _default;